import React from "react";
import { Route, Redirect } from "react-router-dom";
import { useMe, useMyPermissions } from "../actions/auth";
import { getAuthIntent } from "../_helpers/auth";
import log from "cslog";

function PrivateRoute({ component: Component, ...rest }) {
    const hasAuthIntent = getAuthIntent();
    const { isLoading, isFetching, isSuccess, data } = useMe(hasAuthIntent);
    const { isLoading: loadingPermi, data: dataPermi } =
        useMyPermissions(hasAuthIntent);
    const isLoggedIn = isSuccess && data?.data !== undefined;
    const isMobileVerified = isSuccess && data?.data?.mobile_verified;

    log.d(data, "Me in PrivateRoute");

    return (
        <Route
            {...rest}
            render={(props) => {
                if (!isLoading && !loadingPermi && !isFetching && !isLoggedIn) {
                    return (
                        <Redirect
                            to={{
                                pathname: "/login",
                                state: { from: props.location },
                            }}
                        />
                    );
                }
                // else if (!isMobileVerified) {
                //     return (
                //         <Redirect
                //             to={{
                //                 pathname: "/verify_otp",
                //                 state: { from: props.location },
                //             }}
                //         />
                //     );
                // }
                return <Component {...props} />;
            }}
        />
    );
}

export default PrivateRoute;
